/* ============================================================
   Hero video loops — Cloudinary-concatenated montages of the
   approved storyboard clips (adel/v2/vid/*). Delivered on
   versioned URLs (base clip version), desktop + mobile widths,
   with a first-frame poster.
   ============================================================ */

const CLOUD = "dxd0lmhdr";
const VB = `https://res.cloudinary.com/${CLOUD}/video/upload`;

function loop(base, ver, splices, w) {
  const layers = splices.map((s) => `l_video:adel:v2:vid:${s},fl_splice/fl_layer_apply`).join("/");
  return `${VB}/${layers}/e_fade:900/e_fade:-900,w_${w},q_auto/v${ver}/adel/v2/vid/${base}.mp4`;
}
function poster(base, ver, w) {
  return `${VB}/so_0,w_${w},q_auto,f_auto/v${ver}/adel/v2/vid/${base}.jpg`;
}

/* Desktop = the original 16:9 landscape montages (j1-j4, e1-e4).
   Mobile  = separate 9:16 portrait-native montages (jm and em series),
   composed for the phone so faces stay in frame, not cropped to a torso.
   Employer beat 4 reuses the jobseeker frame-4 clip (jm4). */
export const HERO_VIDEO = {
  candidate: {
    desktop: loop("j1", 1784750777, ["j2", "j3", "j4"], 1280),
    mobile: loop("jm1", 1784757921, ["jm2", "jm3", "jm4"], 1080),
    poster: poster("j1", 1784750777, 1280),
    posterMobile: poster("jm1", 1784757921, 1080),
  },
  employer: {
    desktop: loop("e1", 1784750795, ["e2", "e3", "e4"], 1280),
    mobile: loop("em1", 1784757942, ["em2", "em3b", "jm4"], 1080),
    poster: poster("e1", 1784750795, 1280),
    posterMobile: poster("em1", 1784757942, 1080),
  },
};
